import React, { useEffect } from 'react';
import DrawerController from './DrawerController';
import Channel from '../Channel/Channel';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../store/reducers/persistedReducer';

import styles from './MainController.module.scss'
import { tokenTimeToExp } from '../utils/utils';
import Log from '../utils/Log';
import { doRefreshToken, doLogoutUser } from '../store/actions/user';
import { selectIsUserGuest } from '../store/selectors';

let validityTimer: number;
let refreshFails: number = 0;

export default function MainController() {
  const drawerOpen = useSelector((state: RootState) => state.drawer !== "none" && state.drawer !== "")
  const {authSourceToken, token } = useSelector((state: RootState) => state.user)
  const userIsGuest = useSelector(selectIsUserGuest);
  const dispatch = useDispatch();

  // Refresh token background async with timer
  useEffect(() => {
    const checkTokenValidity = () => {
      // Logging for timer
      // const timetoExp = tokenTimeToExp(token);
      // Log.info(timetoExp.toString(), "refreshTimer");

      if (tokenTimeToExp(token) < 300 && (userIsGuest || typeof authSourceToken !== "undefined")) {
        Log.info("Refresh!", "refreshTimer");

        // @TODO fix promise thunk typings somehow.
        (dispatch(doRefreshToken(userIsGuest, authSourceToken)) as unknown as Promise<any>).then(response => {
          // If the return was not a skipped/locked return, reset the fail counter
          if (typeof response === "object" && response?.skipped === true) {
            Log.info("Refresh Skipped", "refreshTimer");
          } else if (refreshFails > 0) {
            refreshFails = 0;
          }
        }).catch(error => {
          // Wait 10 fails (30 seconds) to log out.
          if (error === "unknown" && refreshFails < 10) {
            refreshFails++;
          } else {
            dispatch(doLogoutUser(error === "unknown" ? "An unknown error has occured" : error));
          }
        });
      }

      validityTimer = window.setTimeout(() => {
        checkTokenValidity();
      }, 1000*3) // 3 seconds
    }

    checkTokenValidity();

    return function cleanup() {
      window.clearTimeout(validityTimer);
    }
  }, [dispatch, token, authSourceToken, userIsGuest])


  let classes = ["MainController"];

  if (drawerOpen) {
    classes.push("MainController--drawer-open");
  }

  return (
    <div className={drawerOpen ? styles.drawerOpen : styles.controller}>
      <DrawerController />
      <Channel />
    </div>
  )
}
